var render = function (_h,_vm) {var _c=_vm._c;return _c('PRentalStatus',{attrs:{"status":_vm.props.item[_vm.props.value]}})}
var staticRenderFns = []

export { render, staticRenderFns }